import { render, staticRenderFns } from "./form.vue?vue&type=template&id=1dd3d3fa&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=1dd3d3fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd3d3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd3d3fa')) {
      api.createRecord('1dd3d3fa', component.options)
    } else {
      api.reload('1dd3d3fa', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=1dd3d3fa&scoped=true", function () {
      api.rerender('1dd3d3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifeVibesPoint/form.vue"
export default component.exports